var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandingEndArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 159.227,
    height: 169.443,
    viewBox: "0 0 159.227 169.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16163",
    transform: "translate(-428.895 -2693.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10427",
    d: "M0,0V80.5",
    transform: "translate(430.5 2695)",
    fill: "none",
    stroke: "#1fba9c",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10422",
    d: "M-.023-69.394S2.232-29.383,40.718-12.034,153.919,0,153.919,0",
    transform: "translate(430.5 2844.5)",
    fill: "none",
    stroke: "#1fba9c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16008",
    transform: "translate(-880.382 3298.933) rotate(-45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_420",
    x2: 22.417,
    transform: "translate(1335.471 715.888)",
    fill: "none",
    stroke: "#1fba9c",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_421",
    y2: 22.417,
    transform: "translate(1357.888 693.471)",
    fill: "none",
    stroke: "#1fba9c",
    strokeLinecap: "round",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingEndArrow);
export default __webpack_public_path__ + "static/media/landingEndArrow.61fb64c24016a2636c5d79c252fb0270.svg";
export { ForwardRef as ReactComponent };